<template>
  <div class="sn-pagination px-2 d-flex justify-space-around align-center">
    <div class="sn-body-2 d-flex justify-start align-center">
      <v-icon
        data-cy="page-back"
        data-pendo="['TogglePagination','PreviousPagination']"
        color="black"
        dense
        class="pointer mr-4 sn-font-weight-bold"
        :disabled="(pagination.page === 1 || filteredTotal === 0) "
        @click="handlePaginationBtn('back')"
      >
        sn-icon-chevron-left
      </v-icon>
      <span data-cy="pagination-page-count">
        {{ pageStart }}-{{ pageStop }} of {{ filteredTotal }}
      </span>
      <v-icon
        data-cy="page-forward"
        data-pendo="['TogglePagination','NextPagination']"
        color="black"
        dense
        class="pointer ml-4 sn-font-weight-bold"
        :disabled="(pagination.page === pageCount || filteredTotal === 0)"
        @click="handlePaginationBtn('forward')"
      >
        sn-icon-chevron-right
      </v-icon>
    </div>
    <div class="d-flex align-center justify-start sn-body-2">
      <v-menu
        v-model="perPageOpen"
        elevation="0"
        offset-y
        top
      >
        <template v-slot:activator="{ on }">
          <div
            data-cy="pagination-menu"
            :data-pendo="snInputProps_pendo + '-OpenPaginationMenu'"
            class="pointer"
            v-on="on"
          >
            {{ pagination.itemsPerPage }} per page
            <v-icon color="black">
              $snDownTriangleFilled
            </v-icon>
          </div>
        </template>
        <v-list
          class="sn-body-2 pa-0"
          color="white"
          elevation="0"
          data-cy="pagination-options"
        >
          <v-list-item
            v-for="pageOption in perPageOptions"
            :key="pageOption"
            :data-cy="`page-option-${pageOption}`"
            @click="setPerPage(pageOption)"
          >
            <v-list-item-title>
              <span>{{ pageOption }}</span>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </div>
</template>

<script>
import SnInputProps from '~/components/snui/v2/props/SnInputProps'

export default {
  name: 'SnPagination',
  props: {
    ...SnInputProps,
    perPageOptions: {
      type: Array,
      required: false,
      default: () => [10, 30, 50, 100]
    },
    pagination: {
      type: Object,
      required: true
    },
    filteredTotal: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      perPageOpen: false
    }
  },
  computed: {
    pageStart () {
      if (this.filteredTotal === 0) {
        return 0
      }
      return (this.pagination.page - 1) * this.pagination.itemsPerPage + 1
    },
    pageStop () {
      if (this.filteredTotal === 0) {
        return 0
      }
      if (this.pagination.page === this.pageCount) {
        return this.filteredTotal
      } else {
        return this.pagination.page * this.pagination.itemsPerPage
      }
    },
    pageCount () {
      return Math.ceil(this.filteredTotal / this.pagination.itemsPerPage)
    }
  },
  methods: {
    handlePaginationBtn (direction) {
      if (direction === 'forward') {
        if (this.pagination.page < this.pageCount) {
          this.$emit('pagination', { ...this.pagination, page: this.pagination.page + 1 })
        }
      } else if (this.pagination.page > 1) {
        this.$emit('pagination', { ...this.pagination, page: this.pagination.page - 1 })
      }
    },
    setPerPage (perPage) {
      if (perPage === 'All') {
        perPage = this.filteredTotal
      }
      this.$emit('pagination', { ...this.pagination, itemsPerPage: perPage, page: 1 })
      this.perPageOpen = false
    }
  }
}
</script>

<style scoped lang="scss">
@import '~/assets/css/snui';

.sn-pagination {
  width: 100%;
  max-width: 330px;
}

.pointer {
  cursor: pointer;
}
</style>
